'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPlainAction = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduce = require('lodash/reduce');

var _reduce2 = _interopRequireDefault(_reduce);

var _omitBy = require('lodash/omitBy');

var _omitBy2 = _interopRequireDefault(_omitBy);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var toUpperSnake = function toUpperSnake(val) {
  return val.replace(/[A-Z]/g, function (char) {
    return '_' + char;
  }).toUpperCase();
};

var generateActions = function generateActions(actions, namespace) {
  return (0, _reduce2.default)(actions, function (prev, action, type) {
    return _extends({}, prev, _defineProperty({}, type, function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (0, _omitBy2.default)({
        type: toUpperSnake(namespace + '/' + type),
        payload: typeof action() === 'function' ? function (state) {
          return action.apply(undefined, args)(state);
        } : action.apply(undefined, args)
      }, _isUndefined2.default);
    }));
  }, {});
};

var getPlainAction = exports.getPlainAction = function getPlainAction(action) {
  return { type: action.type, payload: action.payload.toString() };
};

exports.default = generateActions;